<template>
    <div id="contents" class="contents top-page">

        <section class="section-main">
            <div class="txtSafeArea">
                <div class="txtGroup">
                    <p id="txt02" class="txt02" >A Journey to the<br>True Spirit of Japan</p>
                </div>
                <div class="bg">
                    <div class="carousel">
                        <div class="carousel-container">
                            <div class="carousel-track" :style="trackStyle" @transitionend="handleTransitionEnd">
                                <img v-for="(image, index) in clonedImages" :key="index" :src="image" class="carousel-image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="topBanner">
                <a href="https://biz.knt.co.jp/tour/2023/japan_heritage/" target="_blank" rel="noopener noreferrer"><span></span></a>
            </div>
        </section>

        <section class="section-outline">
            <div class="txt01">
                <h1 class="txt01">Japan Heritage, designated by the country’s Agency for Cultural Affairs,
                    <br>organizes Japan’s rich array of cultural assets into themes that convey their
                    <br>historical contexts and significance.</h1>
            </div>
        </section>

        <section class="section01">
            <h2><span class="_dib">EDITOR'S PICKS</span></h2>
            <div class="inner">
                <div class="group">
                    <div class="left">
                        <router-link :to="{name: 'SpiritOfJapan7'}">
                            <div class="img"><img src="../../assets/spirit_of_japan7/main01.webp" alt=""></div>
                            <div class="texts">
                                <div class="category">SPIRIT OF JAPAN</div>
                                <h3>“O-sake” — the drink that nurtured Japanese history</h3>
                                <div class="lead">Since ancient times, Japanese people have held a deep respect for water, which has been used down through the centuries to produce various sake (rice wines) reflecting the unique customs of each region.
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <div class="right">
                        <router-link :to="{name: 'LuxuryTravel05'}">
                            <div class="img"><img src="../../assets/luxury_travel/luxury_travel05/ex04.jpg" alt=""></div>
                            <div class="texts">
                                <div class="category">LUXURY</div>
                                <h3>Colors of Tradition: The Red Crafts of Okayama</h3>
                            </div>
                        </router-link>
                        <router-link :to="{name: 'DiscoverMore2'}">
                            <div class="img"><img src="../../assets/discover_more2/Sake.jpg" alt=""></div>
                            <div class="texts">
                                <div class="category">DISCOVER MORE</div>
                                <h3>Exploring the Sake Regions of Itami and Nada</h3>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </section>

        <section class="section02">
            <h2><span class="_dib">Featured Japan Heritage Sites</span></h2>
            <div class="inner">
                <ul>
                    <li>
                        <router-link :to="{name: 'Popular', params: {id: 'c5885989-a54d-452b-8c63-9f06558da5fb', page: 'about', url: 'aizu-buddhist-pilgrimage-off-beaten-track-fukushima'}}">
                            <div class="img"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/aizu/property05.jpg" alt=""></div>
                            <div class="lead">Aizu: A Buddhist Pilgrimage off the Beaten Track</div>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{name: 'Popular', params: {id: 'e561822d-ce94-4557-9f1a-7d6b09ee543b', page: 'about', url: 'hizen-region-cradle-japanese-porcelain-saga-nagasaki'}}">
                            <div class="img"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/hizen/attraction.jpg" alt=""></div>
                            <div class="lead">Hizen: Region The Cradle of Japanese Porcelain</div>
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{name: 'Popular', params: {id: '88d07209-8204-4b75-bf82-d01e93644112', page: 'about', url: 'mitoku-misasa-hot-springs-climb-healing-tottori-nageiredo'}}">
                            <div class="img"><img src="https://cb-contents.s3-ap-northeast-1.amazonaws.com/articles/images/misasa/story01.jpg" alt=""></div>
                            <div class="lead">Mt. Mitoku and Misasa Hot Springs</div>
                        </router-link>
                    </li>
                </ul>
            </div>
        </section>

        <section class="section-category">
            <div class="inner">
                <div class="group">
                    <div class="leftArea">
                        <p class="txt">Which category<br>are you interested in?</p>
                    </div>
                    <div class="rightArea">
                        <ul>
                            <li><router-link :to="{name: 'FullList', hash: '#history_and_culture', query: { tab: 'category' }}">History and culture</router-link></li>
                            <li><router-link :to="{name: 'FullList', hash: '#nature', query: { tab: 'category' }}">Nature</router-link></li>
                            <li><router-link :to="{name: 'FullList', hash: '#religion_and_beliefs', query: { tab: 'category' }}">Religion and beliefs</router-link></li>
                            <li><router-link :to="{name: 'FullList', hash: '#cultural_experiences', query: { tab: 'category' }}" style="font-size: 2.4rem">Cultural experiences</router-link></li>
                        </ul>
                    </div>
                </div>
                <div class="map"
                     :class="{ '-hokkaidoHover' : isHovering.hokkaido,
                               '-tohokuHover' : isHovering.tohoku,
                               '-hokurikuHover' : isHovering.hokuriku,
                               '-kantoHover' : isHovering.kanto,
                               '-tokaiHover' : isHovering.tokai,
                               '-kansaiHover' : isHovering.kansai,
                               '-chugokuHover' : isHovering.chugoku,
                               '-shikokuHover' : isHovering.shikoku,
                               '-kyushuHover' : isHovering.kyushu,
                               '-okinawaHover' : isHovering.okinawa, }"
                     >
                    <p class="txt">Or, select a region</p>
                    <ul class="region">
                        <li @mouseover="isHovering.hokkaido = true" @mouseleave="isHovering.hokkaido = false"><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'hokkaido' }}">Hokkaido</router-link></li>
                        <li @mouseover="isHovering.tohoku = true" @mouseleave="isHovering.tohoku = false"><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'tohoku' }}">Tohoku</router-link></li>
                        <li @mouseover="isHovering.hokuriku = true" @mouseleave="isHovering.hokuriku = false"><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'hokuriku' }}">Hokuriku Shinetsu</router-link></li>
                        <li @mouseover="isHovering.kanto = true" @mouseleave="isHovering.kanto = false"><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'kanto' }}">Kanto</router-link></li>
                        <li @mouseover="isHovering.tokai = true" @mouseleave="isHovering.tokai = false"><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'tokai' }}">Tokai</router-link></li>
                        <li @mouseover="isHovering.kansai = true" @mouseleave="isHovering.kansai = false"><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'kansai' }}">Kansai</router-link></li>
                        <li @mouseover="isHovering.chugoku = true" @mouseleave="isHovering.chugoku = false"><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'chugoku' }}">Chugoku</router-link></li>
                        <li @mouseover="isHovering.shikoku = true" @mouseleave="isHovering.shikoku = false"><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'shikoku' }}">Shikoku</router-link></li>
                        <li @mouseover="isHovering.kyushu = true" @mouseleave="isHovering.kyushu = false"><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'kyushu' }}">Kyushu</router-link></li>
                        <li @mouseover="isHovering.okinawa = true" @mouseleave="isHovering.okinawa = false"><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'okinawa' }}">Okinawa</router-link></li>
                    </ul>
                    <ul class="region2 sp-only">
                        <li><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'hokkaido' }}">Hokkaido</router-link></li>
                        <li><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'tohoku' }}">Tohoku</router-link></li>
                        <li><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'hokuriku' }}">Hokuriku Shinetsu</router-link></li>
                        <li><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'kanto' }}">Kanto</router-link></li>
                        <li><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'tokai' }}">Tokai</router-link></li>
                        <li><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'kansai' }}">Kansai</router-link></li>
                        <li><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'chugoku' }}">Chugoku</router-link></li>
                        <li><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'shikoku' }}">Shikoku</router-link></li>
                        <li><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'kyushu' }}">Kyushu</router-link></li>
                        <li><router-link :to="{name: 'FullList', hash: '#region', query: { tab: 'region', map: 'okinawa' }}">Okinawa</router-link></li>
                    </ul>
                </div>
            </div>
        </section>

        <section class="section-others">
            <div class="recommend1">
                <router-link :to="{name: 'PlanYourVisit'}">
                    <div class="ttl">Recommended<br>Itineraries</div>
                    <div class="link"><span>See all</span></div>
                    <div class="imgs">
                        <ul>
                            <li><img src="../../assets/index/img_others01_01.jpg" alt=""></li>
                            <li><img src="../../assets/index/img_others01_02.jpg" alt=""></li>
                            <li><img src="../../assets/index/img_others01_03.jpg" alt=""></li>
                            <li><img src="../../assets/index/img_others01_04.jpg" alt=""></li>
                        </ul>
                    </div>
                </router-link>
            </div>
            <div class="video">
                <router-link :to="{name: 'Movies'}">
                    <div class="ttl">Japan Heritage<br>Videos</div>
                    <div class="link">See all</div>
                </router-link>
            </div>
            <div class="bnr">
                <ul>
                    <li><a href="https://biz.knt.co.jp/tour/2023/japan_heritage/" target="_blank"><img src="../../assets/index/img_others04_09.jpg" alt=""></a></li>
                    <li><a href="https://cb.bunka.go.jp/en" target="_blank"><img src="../../assets/index/img_others04_08.png" alt=""></a></li>
                    <li><a href="https://japanculturalexpo.bunka.go.jp/en/" target="_blank"><img src="../../assets/index/img_others04_03.png" alt=""></a></li>
                    <li><a href="https://wattention.com/" target="_blank"><img src="../../assets/index/img_others04_07.png" alt=""></a></li>
                    <li><a href="https://allabout-japan.com/en/" target="_blank"><img src="../../assets/index/img_others04_05.png" alt=""></a></li>
                    <li><a href="https://matcha-jp.com/en" target="_blank"><img src="../../assets/index/img_others04_06.png" alt=""></a></li>
                    <li><a href="https://www.wowu.jp/?locale=en/" target="_blank"><img src="../../assets/index/img_others04_01.png" alt=""></a></li>
                    <li><a href="https://www.japan.travel/en/enjoymyjapan/tradition/?utm_source=bunka&utm_medium=banner&utm_campaign=2021_gc_emj&utm_content=en_japan-heritage" target="_blank"><img src="../../assets/index/img_others04_04.png" alt=""></a></li>
                </ul>
            </div>
        </section>

    </div>
</template>

<script>
    import ApiRouter from "../../components/Systems/ApiRouter";
    import ErrorHandler from "../../components/Systems/ErrorHandler";
    import 'video.js/dist/video-js.css';
    import D8G5540aa from '../../assets/index/top/01_D8G5540aa.jpg';
    import D8G5318c from '../../assets/index/top/02_D8G5318c.jpg';
    // import D8G3746baa from '../../assets/index/top/03_D8G3746baa.jpg';
    // import D8G4122ab from '../../assets/index/top/04_D8G4122ab.jpg';
    import D8G3848a from '../../assets/index/top/05_D8G3848a.jpg';
    import D8G5897ba from '../../assets/index/top/06_D8G5897ba.jpg';
    // import D8G3049ahb from '../../assets/index/top/07_D8G3049ahb.jpg';


    export default {
        name: "Index",
        mixins: [ApiRouter, ErrorHandler],
        data: function () {
            return {
                articles: [],
                loadedVideo: true,
                windowWidth: window.innerWidth,
                windowHeight: window.innerHeight,
                topSpImage: '',
                topSpImages: ['', '_01', '_02', '_03', '_04', '_05', '_06', '_07', '_08', '_09', '_10'],
                sliderSetting: {
                    fade: true,
                    arrows: false,
                    speed: 0,
                    lazyLoad: "ondemand"
                },
                isHabasema: false,
                isHovering: {
                    hokkaido: false,
                    tohoku: false,
                    hokuriku: false,
                    kanto: false,
                    tokai: false,
                    kansai: false,
                    chugoku: false,
                    shikoku: false,
                    kyushu: false,
                    okinawa: false,
                },
                videoOptions: {
                    autoplay: 'true',
                    controls: false,
                    preload: 'none',
                    fluid: true,
                    loop: true,
                    muted: true,
                    sources: [
                        {
                            src: `${process.env.VUE_APP_VIDEO_URL}` + "/streaks/top/top_movie_luxury06.m3u8",
                        }
                    ],
                },
                publicPath: `${process.env.VUE_APP_PUBLIC_PATH}`,
                images: [
                    D8G5540aa,
                    D8G5318c,
                    D8G3848a,
                    D8G5897ba,
                ],
                currentIndex: 0,
                isTransitioning: false
            }
        },
        computed: {
            clonedImages() {
                return [
                    this.images[this.images.length - 1], // 最後の画像を最初に複製
                    ...this.images,
                    this.images[0] // 最初の画像を最後に複製
                ];
            },
            trackStyle() {
                const transition = this.isTransitioning ? 'transform 0.5s ease-in-out' : 'none';
                return {
                    transform: `translateX(-${(this.currentIndex + 1) * 100}%)`,
                    transition
                };
            }
        },
        created: function () {
            this.loadData();
            this.randomlyChooseTopImage();
            document.title = 'Japan Heritage Official Site | Stories and travel information | JNTO'
        },
        mounted: function () {

            // 初回 popupAnimation 呼び出し
            const elements = document.querySelectorAll('[data-js="popupAnimation"]');
            elements.forEach(element => {
                this.popupAnimation(element);
            });

            this.calcAspect();

            let resizeTimerId = null;
            window.addEventListener('resize', ()=>{
                clearTimeout(resizeTimerId);
                resizeTimerId = setTimeout(()=>{
                    this.handleResize();
                }, 50);
            });

            let scrollTimerId = null;
            window.addEventListener('scroll', ()=>{
                clearTimeout(scrollTimerId);
                scrollTimerId = setTimeout(()=>{
                    this.handleScroll();
                }, 50);
            });

            // 「Luxury Destinations」部分のJS呼び出し
            let url = this.publicPath + 'js/luxurytravel.js';
            let recaptchaScript = document.createElement('script');
            recaptchaScript.setAttribute('src', url);
            document.head.appendChild(recaptchaScript);

            this.startSlideShow();

        },
        beforeDestroy: function () {
            window.removeEventListener('resize', this.handleResize);
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            loadData: function () {
                window.axios.get(this.routes.articles)
                    .then((response) => {
                        this.articles = response.data.data;
                    });
            },
            randomlyChooseTopImage: function () {
                this.topSpImage = this.topSpImages[Math.floor(Math.random() * this.topSpImages.length)];
            },
            articleCardHasClicked: function (id, hash) {
                this.$router.push({name: 'Popular', params: {id: id, page: 'travelInfo'}, hash: hash});
            },
            videoHasLoaded: function () {
                this.loadedVideo = true;
            },
            handleResize: function () {
                this.windowWidth = window.innerWidth;
                this.windowHeight = window.innerHeight;
                this.calcAspect();
            },
            calcAspect: function () {
                const width = window.innerWidth;
                const height = window.innerHeight;
                if (height > width * 0.43333) {
                    this.isHabasema = true;
                } else {
                    this.isHabasema = false;
                }
            },
            handleScroll: function () {
                const elements = document.querySelectorAll('[data-js="popupAnimation"]');
                elements.forEach(element => {
                    this.popupAnimation(element);
                });
            },
            popupAnimation: function (element) {
                const state = element.getAttribute('data-popupAnimation-state');
                const delay = element.getAttribute('data-popupAnimation-delay');
                if (state === 'notMoved') {
                    const topHeight = element.getBoundingClientRect().top;
                    const startPosition = element.getAttribute('data-popupAnimation-start');
                    if (topHeight < this.windowHeight - startPosition) {
                        setTimeout(() => {
                            element.setAttribute('data-popupAnimation-state', 'moved');
                        }, delay);

                    }
                } else {
                    if (element.getBoundingClientRect().top > this.windowHeight) {
                        element.setAttribute('data-popupAnimation-state', 'notMoved');
                    }
                }
            },
            startSlideShow() {
                setInterval(() => {
                    this.nextSlide();
                }, 7000);
            },
            nextSlide() {
                if (!this.isTransitioning) {
                    this.isTransitioning = true;
                    this.currentIndex++;
                }
            },
            handleTransitionEnd() {
                this.isTransitioning = false;

                if (this.currentIndex === this.images.length) {
                    this.currentIndex = 0;
                } else if (this.currentIndex === -1) {
                    this.currentIndex = this.images.length - 1;
                }
            }
        }
    }
</script>

<style src="./Index.scss" lang="scss" scoped/>
